export const CATALOGUE_ACTIONS = {
    CATALOGUE_SEARCH: 'CATALOGUE_SEARCH',
    CATALOGUE_SEARCH_SUCCESS: 'CATALOGUE_SEARCH_SUCCESS',
    CATALOGUE_SEARCH_ERROR: 'CATALOGUE_SEARCH_ERROR',

    CATALOGUE_UPSERT: 'CATALOGUE_UPSERT',
    CATALOGUE_UPSERT_SUCCESS: 'CATALOGUE_UPSERT_SUCCESS',
    CATALOGUE_UPSERT_ERROR: 'CATALOGUE_UPSERT_ERROR',

    CATALOGUE_EDIT: 'CATALOGUE_EDIT',

    CATALOGUE_RESET: 'CATALOGUE_RESET',
};

export const catalogueResetAction = () => ({
    type: CATALOGUE_ACTIONS.CATALOGUE_RESET,
});

export const catalogueSearchAction = (payload) => ({
    type: CATALOGUE_ACTIONS.CATALOGUE_SEARCH,
    ...payload,
});

export const catalogueEditAction = (payload) => ({
    type: CATALOGUE_ACTIONS.CATALOGUE_EDIT,
    ...payload,
});

export const catalogueUpsertAction = (payload) => ({
    type: CATALOGUE_ACTIONS.CATALOGUE_UPSERT,
    ...payload,
});

export default {
    CATALOGUE_ACTIONS,
    catalogueSearchAction,
    catalogueUpsertAction,
    catalogueEditAction,
};
